/*
 * The english translation of all files relating to the AdminView
 */
export const ADMIN_VIEW_EN = {
  // UserTableDropDown.vue
  updateUser: 'Update User',
  resetUserPassword: 'Reset Password',
  // useAdminNavigation.ts
  createOrganisation: 'CREATE ORGANISATION',
  // OrgaAdminUserUpdate.vue
  updateUserDescription: "Update a user. Click save when you're done.",
  typeTheFullName: 'Type the full name.',
  notEditable: 'not editable',
  usersEmailAddress: "User's email address",
  pleaseTypeInAName: 'Please type in a name',
  nameMustBeAtLeastTwoCharacters: 'Name must be at least 2 characters',
  nameMustNotBeLongerThanThirtyCharacters: "Name mustn't be longer than 30 characters",
  promptName: 'Prompt Name',
  // Affiliate Management
  affiliates: 'Affiliates',
  createAffiliate: 'Create Affiliate',
  affiliateCode: 'Affiliate Code',
  partnerName: 'Partner Name',
  partnerEmail: 'Partner Email',
  trialExtensionDays: 'Trial Extension Days',
  signUps: 'Sign-ups',
  conversions: 'Conversions',
  mrr: 'MRR',
  deactivate: 'Deactivate',
  noAffiliatesFound: 'No affiliates found',
  affiliateCreated: 'Affiliate code created'
}
/*
 * The german translation of all files relating to the AdminView
 */
export const ADMIN_VIEW_DE = {
  // UserTableDropDown.vue
  updateUser: 'Benutzer aktualisieren',
  resetUserPassword: 'Passwort zurücksetzen',
  // useAdminNavigation.ts
  createOrganisation: 'ORGANISATION ERSTELLEN',
  // OrgaAdminUserUpdate.vue
  updateUserDescription:
    'Aktualiseren Sie einen Benutzer. Klicken Sie speichern, wenn Sie fertig sind.',
  typeTheFullName: 'Tippen Sie den vollen Namen ein.',
  notEditable: 'nicht bearbeitbar',
  usersEmailAddress: 'Email Addresse des Benutzers',
  pleaseTypeInAName: 'Bitte geben Sie einen namen ein',
  nameMustBeAtLeastTwoCharacters: 'Name muss mindestens 2 Zeichen lang sein.',
  nameMustNotBeLongerThanThirtyCharacters: 'Name darf nicht länger als 30 Zeichen sein.',
  promptName: 'Prompt Name',
  // Affiliate Management
  affiliates: 'Affiliates',
  createAffiliate: 'Affiliate erstellen',
  affiliateCode: 'Affiliate-Code',
  partnerName: 'Partnername',
  partnerEmail: 'Partner-E-Mail',
  trialExtensionDays: 'Testverlängerung (Tage)',
  signUps: 'Anmeldungen',
  conversions: 'Konvertierungen',
  mrr: 'MRR',
  deactivate: 'Deaktivieren',
  noAffiliatesFound: 'Keine Affiliates gefunden',
  affiliateCreated: 'Affiliate-Code erstellt'
}
